import ApiService from '../../../shared/services/ApiService';

export default {
    payrollEarlyAccess(data) {
        return ApiService.post('/payroll-early-access', data)
    }
}